export default "__VITE_ASSET__f9445933__"